import { deepest } from '../utils';
import { BREAKPOINT_LARGE, BREAKPOINT_MED, HTML_WIDTH } from '../variables';

export default function menuFunctionality() {
  subMenuBtn();
  desktopMenu();
  writeOutLevels();
  openMobileMenu();
  addMenuClickHandlers();
}

function addMenuClickHandlers() {
  $('.submenu-btn').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (HTML_WIDTH >= BREAKPOINT_MED) {
      const parent = $(this).parent().parent();
      const grandparent = $(parent).parent();
      let close = false;
      if ($('.sub-menu', parent).first().hasClass('open')) {
        close = true;
      }
      $('.open', grandparent).removeClass('open');
      $('a.active', grandparent).removeClass('active');
      if (!close) {
        $('.sub-menu', parent).first().addClass('open');
        $(this).closest('a').addClass('active');
      }
      let height = 0;
      $('.navigation > li > .open > li').each(function () {
        height += $(this).outerHeight();
      });
      $('.navigation ul ul').each(function () {
        if ($(this).hasClass('open')) {
          if ($(this).height() > height) {
            height = $(this).height();
          }
        }
      });
      $('.navigation > li > ul').css('height', height);
    }
    if (HTML_WIDTH < BREAKPOINT_MED) {
      $(this).parent().parent().find('.sub-menu:first').addClass('open');
      $(this).closest('a').addClass('active');
      $(this).parent().parent().addClass('show-div');
      $(this).parent().parent().siblings().addClass('hide-div');
      let name;
      if ($(this).parent().hasClass('level1')) {
        $('.main-menu-mobile-extras').addClass('hide');
        if (document.documentElement.lang == 'sv-SE') {
          name = 'Meny';
        } else {
          name = 'Menu';
        }
      } else {
        name = $(this).parent().parent().parent().parent().find('a:first').text();
      }
      $('#mobile-menu-header-div').addClass('show');
      $('#mobile-menu-header-div').text(name);
    }
  });

  $('#mobile-menu-header-div').click(function() {
    const subMenu = document.querySelector('.primary-menu__nav .menu');
    const target = deepest(subMenu, '.open');
    $(target).removeClass('open');
    $(target).parent().find('a:first').removeClass('active');
    $(target).parent().removeClass('show-div');
    $(target).parent().siblings().removeClass('hide-div');

    const level = deepest(subMenu, '.open');
    const name = $(level).parent().parent().parent().find('a:first').text();
    if ($('#mobile-menu-header-div').text() == name) {
      if (document.documentElement.lang == 'sv-SE') {
        $('#mobile-menu-header-div').text('Meny');
      } else {
        $('#mobile-menu-header-div').text('Menu');
      }
    } else {
      $('#mobile-menu-header-div').text(name);
    }

    if (subMenu == level) {
      $('.main-menu-mobile-extras').removeClass('hide');
      $('#mobile-menu-header-div').removeClass('show');
      $('#mobile-menu-header-div').text('');
    }
  });

  $('.navigation .level1').click(function(e) {
    if (HTML_WIDTH >= BREAKPOINT_MED && $(this).parent().hasClass('menu-item-has-children')) {
      e.preventDefault();
      $(this).children('.submenu-btn').trigger('click');
    }
  });

  $('.navigation .level2').click(function(e) {
    if (HTML_WIDTH >= BREAKPOINT_MED && $(this).parent().hasClass('menu-item-has-children')) {
      e.preventDefault();
      $(this).children('.submenu-btn').trigger('click');
    }
  });

  if (HTML_WIDTH < BREAKPOINT_MED) {
    $('.primary-menu__nav .menu li').each(function() {
      if ($('>.sub-menu', this).length) {
        $('>a', this).click(function(e) {
          e.preventDefault();
          $('.submenu-btn', this).trigger('click');
        });
      }
    });
  }
}

function subMenuBtn() {
  $('.menu-item-has-children').find('a:first').append('<span class="submenu-btn"><i class="submenu-open-btn" aria-hidden="true"></i> </span>');
}

function openMobileMenu() {
  $('.toggle-menu, .close-btn').click(function() {
    $('.main-menu, .close-btn, .toggle-menu').toggleClass('open');
    // $('.navigation, .close-btn, .toggle-menu').toggleClass('open'); detta var original
    if ($('.main-menu').hasClass('open')) {
      $('body').css({ overflow: 'hidden' });
    } else {
      $('body').css({ overflow: 'visible' });
    }
    if (HTML_WIDTH < BREAKPOINT_MED) {
      $('.show-search').removeClass('open');
    }
    $('.header-language-picker').toggleClass('mobile-show');

    if ($('.toggle-menu').hasClass('open') && HTML_WIDTH < BREAKPOINT_MED) {
      $('.header-mini-info-bar').addClass('custom-hide');
    } else if (!$('.toggle-menu').hasClass('open') && HTML_WIDTH < BREAKPOINT_MED) {
      $('.header-mini-info-bar').removeClass('custom-hide');
    }
  });
}

function desktopMenu() {
  if (HTML_WIDTH < BREAKPOINT_LARGE) return;

  const parentElement = document.querySelector('.primary-menu__nav .menu');

  $('body').click(function(e) {
    if (!$('.sub-menu').hasClass('open')) return;

    if (parentElement &&
        e.target !== parentElement &&
        !parentElement.contains(e.target)) {
      $('.sub-menu.open').removeClass('open');
    }
  });
}

function writeOutLevels() {
  // Ful lösning för att få ut nivåer :(
  $('.navigation > .menu-item > a').addClass('level1');
  $('.navigation > .menu-item > ul > .menu-item > a').addClass('level2');
}
